import {TrafficOrdersTypes} from "./actionTypes"

export const getTrafficOrdersNotActive = (next_page: string, filter: object) => {
  return {
    type: TrafficOrdersTypes.GET_TRAFFIC_ORDERS_NOT_ACTIVE,
      next_page, filter
  }
};

export const getTrafficOrdersNotActiveSuccess = (data: any) => ({
  type: TrafficOrdersTypes.GET_TRAFFIC_ORDERS_NOT_ACTIVE_SUCCESS,
  payload: data
});

export const getTrafficOrdersNotActiveFail = (error : any) => ({
  type: TrafficOrdersTypes.TRAFFIC_ORDERS_NOT_ACTIVE_FAIL,
  payload: {
    error,
  },
});

export const clearTrafficOrdersNotActive = () => ({
  type: TrafficOrdersTypes.CLEAR_TRAFFIC_ORDERS_NOT_ACTIVE,
});
